const ameblo = window.ameblo = window.ameblo || {};
const content = window.ameblo.content = {};
const ua = window.navigator.userAgent;

content.ua = {
  isAndroid: /android/i.test(ua),
  isIOS: /ip(hone|od|ad)/i.test(ua),
  isApp: /cawebapp.*jpameblo/i.test(ua)
};

if(ameblo.content.ua.isApp) {
  document.body.classList.add('app');
}
